export default __webpack_public_path__ + "static/media/Card Payment_Outline.0cb9ba1a.svg";